const rI = {
  name: 'Refractive index',
  label: 'RI',
};

const uV = {
  name: 'Ultraviolet',
  label: 'UV',
};

const LIST_DETECTORS = [
  rI, uV,
];

export {
LIST_DETECTORS,  // eslint-disable-line
};
